<!-- Client bespoke pages defined in the content table e.g. findhelp -->
<template>
   <PageLoader :isLoading="isLoading" :loadErrors="loadErrors">
      <PageSections v-if="pageContent" :contentSections="pageContent.sections" />
   </PageLoader>
</template>

<script setup lang="ts">
import { useRoute } from "vue-router";
import ContentApi, { type PageContent, type PageResp } from "@/data/api-layer/contentApi";
import { useApiRequest } from "@/composables/useApiRequest";

const route = useRoute();
const contentKey = route.params.key as string;

const pageContent = ref<PageContent>(null);
const { isLoading, execRequest, loadErrors } = useApiRequest();

onMounted(async () => {
   const response: PageResp = await execRequest(() => ContentApi.getBespokeContent(contentKey));

   if (response?.content) pageContent.value = response.content;
   return;
});
</script>
